<template>
    <div class="s_temp_module">
        <div class="topOperation">
            <div class="top-left">
                <ShowNavHead />
            </div>
        </div>
        <div class="main-con">
            <div class="crumbs">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>系统</el-breadcrumb-item>
                    <el-breadcrumb-item>基础配置</el-breadcrumb-item>
                    <el-breadcrumb-item>模板维护</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="s_temp_table">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
                        <template slot-scope="{row}">
                            <span>{{row.sort}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="moduleName" label="模块" align="center"></el-table-column>
                    <el-table-column prop="tempName" label="模板名称" align="center"></el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="{row}">
                          <el-button type="primary" plain size="small" @click="handle1(row)">上传</el-button>
                          <el-button type="success" plain size="small" @click="downLoadHandle(row)">下载</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 上传模板 -->
        <el-dialog title="上传模板" :visible.sync="importDialog" width="500px" class="up_dialog">
            <div class="info_sel" v-if="uploadType == '2'||uploadType == '3'">
                <el-select v-if="uploadType == '3'"
                v-model="uploadQuery.tableid"
                slot="prepend"
                placeholder="请选择要导入的表格类型"
                filterable
                @change="selectObjUpload"
                >
                    <el-option
                        v-for="(item, index) in tableList"
                        :key="index"
                        :label="item.StrTableName"
                        :value="item.StrTableId"
                    ></el-option>
                </el-select>
                <el-select v-if="uploadType == '2'"
                v-model="uploadQuery.tableid"
                placeholder="请选择要导入的表格类型"
                filterable
                @change="selectSignObj"
              >
                <el-option
                  v-for="(item, index) in tempTableList"
                  :key="index"
                  :label="item.StrTableName"
                  :value="item.StrTableId"
                ></el-option>
              </el-select>
            </div>
            <div class="form-item" style="justify-content: space-between;">
                <div class="file-box">
                    <input readonly style="width: 368px;height:32px" id="applyLicense" type="text" v-model="ExcelSrc.fileName" autocomplete="off">
                    <input id="fileInput" type="file" name="file" accept=".xlsx,.xls" @change="importf(this)" ref="upload">
                    <label for="fileInput" class="file-btn">上传</label>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <button class="clear" @click="importDialog=false">取消</button>
                <button  class="search"  style="margin-left:10px;font-weight:600"  @click="confirmImport">确认上传</button>
            </span>
        </el-dialog>
        <!-- 下载模板 -->
        <el-dialog title="下载模板" :visible.sync="downloadDialog" width="500px" class="up_dialog">
          <div style="margin:5px 0">
            <span style="margin-right:4px;">表格类型:</span>
                <el-select v-if="uploadType == '3'"
                v-model="downloadQuery.tableid"
                slot="prepend"
                placeholder="请选择要下载的表格类型"
                filterable
                @change="selectObj"
                >
                    <el-option
                        v-for="(item, index) in tableList"
                        :key="index"
                        :label="item.StrTableName"
                        :value="item.StrTableId"
                    ></el-option>
                </el-select>
                <el-select v-if="uploadType == '2'"
                v-model="downloadQuery.tableid"
                placeholder="请选择要下载的表格类型"
                filterable
                @change="selectTempObj"
              >
                <el-option
                  v-for="(item, index) in tempTableList"
                  :key="index"
                  :label="item.StrTableName"
                  :value="item.StrTableId"
                ></el-option>
              </el-select>
            </div>
          <span slot="footer" class="dialog-footer">
            <button class="clear" @click="downloadDialog=false">取消</button>
            <button  class="search"  style="margin-left:10px;font-weight:600"  @click="downloadConfirm">下载模板</button>
          </span>
        </el-dialog>
    </div>
</template>
  
<script>
import FUN from "./../../fun";
import xz from "./../../common";
import teamReminderVue from '../supplierManage/teamReminder.vue';
export default {
  data() {
    return {
        downloadDialog:false,
        importDialog:false,
        tableData:[
            {
                sort:1,
                tempName:'花名册模板',
                type:1,
                moduleName:'客户/项目/存档花名册'
            },
            {
                sort:2,
                tempName:'批量(待面试/待入职/入职/离职)导入模板',
                type:2,
                moduleName:'雇员/流程管理'
            },
            {
                sort:3,
                tempName:'财务数据源模板',
                type:3,
                moduleName:'财务/财务数据源'
            },
            {
                sort:4,
                tempName:'简历导入模板',
                type:4,
                moduleName:'雇员/人才库/个人资源(公海资源)'
            },
            {
                sort:5,
                tempName:'费用单导入模板',
                type:5,
                moduleName:'产品/灵活用工/费用单列表'
            },
            {
                sort:6,
                tempName:'招聘需求模板',
                type:6,
                moduleName:'雇员/流程管理/招聘需求列表'
            }
        ],
        //上传参数
        uploadQuery:{
            fileid:'',
            url:'',
            tableid:''
        },
        // 财务数据源
        tableList:[
          {
            DtInsertDate: "2022-04-08T15:22:52",
            GdUserId: "04F97C95-DF0F-4E4F-90DB-234E969EB323",
            StrObjInstName:"杰博",
            StrTableId: "XZ_emp_FnncDataSource",
            StrTableName: "财务数据源"
          }
        ],
        // 简历导入下拉选择数据(入职、待面试、离职)
        tempTableList:[{
          StrTableName:'批量导入待面试模板',
          StrTableId:'output_JB_emp_PsnStatusDms'
        },{
          StrTableName:'批量导入待入职模板',
          StrTableId:'output_JB_emp_PsnStatusDrz'
        },{
          StrTableName:'批量导入离职模板',
          StrTableId:'output_JB_emp_UserBaseDepart'
        },{
          StrTableName:'批量导入入职模板（详细）',
          StrTableId:'output_JB_emp_UserBase'
        },{
          StrTableName:'批量信息维护模板',
          StrTableId:'output_JB_emp_UserBaseMainte'
        },{
          StrTableName:'批量导入入职模板（简易）',
          StrTableId:'output_JB_emp_UserBaseSimple'
        }],
        ExcelSrc: {
            value: "",
            check: false,
            fileName: ""
        },
        //错误提醒
        errorTxt:'',
        uploadType:'1',
        downloadQuery: {
          fileid:'',
          tableid:''
        },
        tablePath: this.$store.state.EMP.tablePath
    }
  },
  created() {
    
  },
  methods: {
    // 上传
    handle1(item){
      this.uploadType = item.type
      this.ExcelSrc = {
        value: "",
        check: false,
        fileName: ""
      }
      this.uploadQuery = {
        fileid:'',
        url:'',
        tableid:''
      }
      this.importDialog = true
    },
    // 上传选择表格类型
    selectObjUpload(e) {
      // console.log("d", e);
      let obj = {}
      this.tableList.map((item) => { 
        if(item.StrTableId == e) {
          obj = item
        }
      })
      // console.log('obj',obj)
        this.uploadQuery.fileid = obj.StrTableName
    },
    selectSignObj(e) {
      // console.log("d", e);
      let obj = {}
      this.tempTableList.map((item) => { 
        if(item.StrTableId == e) {
          obj = item
        }
      })
      // console.log('obj',obj)
      this.uploadQuery.fileid = obj.StrTableName
    },
    //下载模板
    downLoadHandle(item){
      this.uploadType = item.type
      if(this.uploadType != '1'&&this.uploadType != '4'&&this.uploadType != '5'&&this.uploadType != '6'){
        this.downloadDialog = true
        this.downloadQuery = {
          fileid:'',
          tableid:''
        }
      }else{
        this.downloadConfirm()
      }
    },
    // 确定下载
    downloadConfirm(){
      // console.log('下载模板',this.downloadQuery)
      if(this.uploadType == '2'||this.uploadType == '3'){
        if(this.isNull(this.downloadQuery.tableid)){
          this.$message.warning('请选择下载的表格类型')
          return
        }
      }
      if(this.uploadType == '5'){
        xz.getcrmOutPutMode('JB_busi_UtilityBill','费用单导入').then(res => {
          // console.log('下载模板', res)
          if(res){
            window.localStorage.setItem('isDownFeeTemplate', new Date());
            let d = res.msg.data.StrOutPath
            d = d.replace("\"", "").replace("\"", "")
            let path = this.tablePath + d
            const aTag5 = document.createElement('a')
            aTag5.href = path
            aTag5.click();
          }else {
            this.$message({
              type: 'error',
              message: '下载失败，请稍后再试'
            })
            return false
          }
        })
      }
      if(this.uploadType == '4'){
        xz.getPsnOutPutMode().then(res => {
          // console.log('下载模板', res)
          if (res) {
              window.localStorage.setItem('isDownResTemplate', new Date());
              let d = res.msg.data.StrOutPath
              d = d.replace("\"", "").replace("\"", "")
              let path = this.tablePath + d
              const aTag4 = document.createElement('a')
              aTag4.href = path
              aTag4.click();
          }else{
            this.$message.warning('下载模板错误，请稍后再试')
          }
        })
      }
      if(this.uploadType == '2'){
        xz.getImportModeUrl(this.downloadQuery.tableid,this.downloadQuery.fileid).then(res => {
          // console.log('下载模板', res)
          if (res.status == 'ok') {
            if(this.downloadQuery.fileid == '批量流程表'){
              window.localStorage.setItem('isFaceDownload', new Date());
            }
            if(this.downloadQuery.fileid == '批量入职表'){
              window.localStorage.setItem('isJobDownload', new Date());
            }
            let d = res.msg.data.StrOutPath
            d = d.replace("\"", "").replace("\"", "")
            let path = this.tablePath + d
            let aTag = document.createElement('a')
            aTag.href = path
            aTag.click();
            this.downloadDialog = false
          }else{
            this.$message.warning('下载模板错误，请稍后再试')
          }
        })
      }
      if(this.uploadType == '6'){
        xz.getImportModeUrl('output_JB_busi_RecrJob','招聘需求表').then(res => {
          // console.log('下载模板', res)
          if (res.status == 'ok') {
            let d = res.msg.data.StrOutPath
            d = d.replace("\"", "").replace("\"", "")
            let path = this.tablePath + d
            let aTag = document.createElement('a')
            aTag.href = path
            aTag.click();
          }else{
            this.$message.warning('下载模板错误，请稍后再试')
          }
        })
      }
      if(this.uploadType == '3'){
        xz.getfinanceinputmode(this.downloadQuery.fileid,'output_'+this.downloadQuery.tableid).then(res=>{
          // console.log('下载模板',res)
          if(res){
            let d = res.msg.data.StrOutPath;
            let path = this.tablePath + d;
            // console.log('path',path)
            const aTag3 = document.createElement('a')
            aTag3.href = path
            aTag3.click()
            this.downloadDialog = false
          }else{
            this.$message.warning('下载模板错误，请稍后再试')
          }
        })
      }
      if(this.uploadType == '1'){
        xz.getImportMode().then(res=>{
          // console.log('下载模板',res)
          if(res){
            let d = res.msg.data.StrOutPath;
            let path = this.tablePath + d;
            // console.log('path',path)
            const aTag2 = document.createElement('a')
            aTag2.href = path
            aTag2.click()
            this.downloadDialog = false
          }else{
            this.$message.warning('下载模板错误，请稍后再试')
          }
        })
      }
    },
    selectTempObj(val){
      if(val == 'output_JB_emp_PsnStatus'){
        this.downloadQuery.fileid = '批量流程表'
      } else if(val == 'output_JB_emp_UserBase'){
        this.downloadQuery.fileid = '批量入职表'
      } else if(val == 'output_JB_emp_UserBaseDepart'){
        this.downloadQuery.fileid = '批量离职表'
      }
    },
    selectObj(val){
      this.downloadQuery.fileid = '财务数据源'
    },
    //文件读取
    importf() {
      let that = this
      let fileInput = that.$refs.upload;
      FUN.returnExcelSrc(fileInput).then(src => {
        if (src) {
          // console.log('src0o0',src)
          this.$set(this.ExcelSrc, "value", src.src);
          this.$set(this.ExcelSrc, "check", false);
          this.$set(this.ExcelSrc, "fileName", fileInput.files[0].name);
          // console.log('srccc',this.ExcelSrc)
           //上传excel
            const excelFile = FUN.base64ToFile(this.ExcelSrc.value,this.ExcelSrc.fileName);
            const formData = new FormData();
            formData.append("pagename", 'empexcel');
            formData.append("action", 'save');
            formData.append("userid", Cookies.get("userid-b"));         
            formData.append("entid", Cookies.get("userid-b"));
            formData.append("excel", excelFile , this.ExcelSrc.fileName);
            console.log('formData',formData)
            xz.uploadCert(formData).then(res => {
            //   console.log('formData',res)
              if(this.isNull(res)||res==false){
                this.$message('上传Excel失败!')
                this.isUploadSuccess = true
              }else{
                this.uploadQuery.url = res;
                if(this.uploadType == '1'){
                  localStorage.setItem('epath',res)
                }
                this.isUploadSuccess = false
                this.errorTxt = ''
                this.$refs['upload'].value = null;
              }
            });
        }else{
            this.$message('上传Excel失败!')
          }
      });
    },
    //确认上传
    confirmImport(){
      // console.log('上传',this.uploadQuery)
      if(this.isNull(this.uploadQuery.url)){
        this.$message.warning('请先上传模板')
        return false
      }
      if(this.uploadType == '4'){// 个人资源
        xz.getpsnExprotMode(this.uploadQuery.url).then(res=>{
          if(res){
            this.importDialog = false;
            this.$message.success('上传成功！')
          }else{
            this.$message.error('上传失败，请稍后再试！')
          }
        })
      }
      if(this.uploadType == '5'){// 费用单导入
        this.uploadQuery.tableid = 'JB_busi_UtilityBill'
        this.uploadQuery.fileid = '费用单导入'
        xz.getcrmExprotMode(this.uploadQuery.tableid,this.uploadQuery.fileid,this.uploadQuery.url).then(res=>{
          if(res.status == 'ok'){
            this.importDialog = false;
            this.$message.success('上传成功！')
          }else{
            this.$message('上传模板失败!')
          }
        })
      }
      if(this.uploadType == '1'){// 花名册
        xz.importModel(this.uploadQuery.url).then(res=>{
          if(res){
            this.importDialog = false;
            this.$message.success('上传成功！')
          }else{
            this.$message.error('上传失败，请稍后再试！')
          }
        })
      }
      if(this.uploadType == '2'){// 简历导入
        if(this.isNull(this.uploadQuery.tableid)){
          this.$message.warning('请选择要导入的表格类型')
          return
        }
        xz.getpsnExprotModeSign(this.uploadQuery.tableid,this.uploadQuery.fileid,this.uploadQuery.url).then(res=>{
          if(res){
            this.importDialog = false;
            this.$message.success('上传成功！')
          }else{
            this.$message.success(res.msg)
          }
        })
      }
      if(this.uploadType == '6'){// 招聘需求
        xz.getpsnExprotModeSign('output_JB_busi_RecrJob','招聘需求表',this.uploadQuery.url).then(res=>{
          if(res){
            this.importDialog = false;
            this.$message.success('上传成功！')
          }else{
            this.$message.success(res.msg)
          }
        })
      }
      if(this.uploadType == '3'){// 财务数据源
        if(this.isNull(this.uploadQuery.tableid)){
          this.$message.warning('请选择模板的类型')
          return false
        }else{
          xz.getfinanceexprotmode(this.uploadQuery.fileid,this.uploadQuery.url,'output_'+ this.uploadQuery.tableid).then(res=>{
            if(res){
              this.importDialog = false;
              this.$message.success('上传成功！')
            }
          })
        }
      }
    },
    //判断是否为空(包含0)或1970
    isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0;
    },
  }
}
</script>

<style scoped>
.s_temp_table{
    padding: 0 0 30px;
    background-color: #fff;
}
.form-item {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
}
.form-item label {
  width: 56px;
  text-align: right;
}
.form-item span {
  color: #ff3228;
}
.form-item input {
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #cccccc;
  padding-left: 14px;
  box-sizing: border-box;
  margin-top: 20px;
}
/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 120px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-btn {
  display:inline-block;
  width: 54px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  text-align: center !important;
  line-height: 32px;
  color: #333333;
  margin-left: 8px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<style>
.info_sel .el-select{
  width: 368px;
}
.info_sel .el-input__inner{
  height: 32px;
  line-height: 32px;
}
.info_sel .is-focus .el-input__suffix{
  top: -4px;
}
.info_sel .el-input__suffix{
  top: 5px;
}
</style>